import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Button, Card, CardContent, Checkbox, FormControl, FormControlLabel, TextField, withStyles } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import TermoUso from "app/Core/Funcionalidade/TermoUso/TermoUso";
import { ReplaceAll } from "app/Core/Helpers";
import FirebaseAuthService from "app/Core/services/FirebaseAuthService";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import classNames from "classnames";
import clsx from "clsx";
import Constante from "Constante.json";
import React from "react";
import InputMask from "react-input-mask";
import connect from "react-redux/es/connect/connect";
import { Link, withRouter } from "react-router-dom";
import { load } from "recaptcha-v3";
import { bindActionCreators } from "redux";
import * as Actions from "../store/actions";
import RegisterReducer from "../store/reducers/RegisterReducer";

const styles = theme => ({
    root: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.primary.contrastText,
        overflow: "hidden"
    },
    paper: {
        width: "70%",
    },
    card: {
        background: theme.palette.type === "dark" ? "#494949" : "#FFFFFF",
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#494949",
        overflow: "auto"
    },
    content: {
        background: theme.palette.type === "dark" ? "#424242" : "#E6E6E6",
        color: theme.palette.type === "dark" ? "#CCC" : "#666",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 10,
    },
    image: {
        display: "flex",
        "@media (max-width: 960px)": {
            display: "none"
        }

    },
    bgTheme: {
        backgroundColor: theme.palette.primary.main
    }
});

class RegisterPage extends XAPPComponent {

    state = {
        nome: "",
        contato: "",
        email: "",
        password: "",
        passwordConfirm: "",
        acceptTermsConditions: false,
        idprojeto: "",
        recaptcha: "",
    };

    componentDidMount() {
        load(Constante.chave_recaptcha).then((recaptcha) => {
            recaptcha.execute("login").then((token) => {
                this.setState(_.set({ ...this.state }, "recaptcha", token));
            });
        });
    }

    componentDidUpdate() {
        if (this.props.Register.error) {
            this.props.showMessage({
                message: this.props.Register.error,
                variant: "error"
            });
            this.props.Register.error = null;
        }
        if (this.props.Register.warning) {
            this.props.showMessage({
                message: this.props.Register.warning,
                variant: "warning"
            });
            this.props.Register.warning = null;
        }
        if (this.props.Register.info) {
            this.props.showMessage({
                message: this.props.Register.info,
                variant: "success"
            });
            this.props.Register.info = null;
        }
    }

    isFormValid = () => {
        const form = this.state;

        return (
            form.recaptcha.length > 0 &&
            form.nome.length > 0 &&
            form.contato.length > 0 &&
            form.email.length > 0 && form.email.includes("@") &&
            form.password.length > 5 &&
            form.passwordConfirm.length > 5 &&
            form.password === form.passwordConfirm &&
            form.acceptTermsConditions
        );
    };

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    handleChangeCheck = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.checked));
    };

    handleChangeMask = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, ReplaceAll(event.target.value, /[^\w\s]/gi, "")));
    };

    handleSubmit() {
        const form = { ...this.state };
        FirebaseAuthService.Register(form)
            .then((resp) => {
                this.props.createUserAuth(resp);
            }).catch((error) => {
                this.props.showMessage(error);
            });
    }

    render() {
        const form = this.state;
        const { classes, theme } = this.props;

        return (
            <React.Fragment>
                <div className={clsx(classes.root, "flex flex-col flex-auto flex-shrink-0 md:flex-row p-0")}>
                    <div className={clsx(classes.image, "flex-col flex-no-grow items-center text-white p-16 text-center md:p-128 md:flex-no-shrink md:flex-1 md:text-left justify-center")}>
                        <div className={classes.paper}>
                            <img
                                className={clsx(classes.bgTheme, "justify-center")}
                                src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                                alt="Logo principal"
                            />
                        </div>
                    </div>
                    <FuseAnimate animation={{ translateX: [0, "100%"] }}>
                        <Card className={classNames(classes.card, "w-full max-w-400 mx-auto m-16 md:m-0")} square>
                            <CardContent className={classNames(classes.content, "flex flex-col items-center justify-center py-32 m-28 md:m-36")}>
                                <img
                                    id="logoPrincipal"
                                    className={clsx(classes.bgTheme, "md:hidden sm:flex mb-12 h-52")}
                                    src={`https://storage.googleapis.com/hexapp-public/logos/${document.location.hostname}/logo_${theme.palette.type}.png`}
                                    alt="Logo principal"
                                />
                                <span className="font-medium text-16 my-32" >NOVA CONTA</span>
                                <div className="flex flex-col justify-center w-full">
                                    <TextField
                                        className="mb-16"
                                        label="Nome"
                                        name="nome"
                                        value={form.nome}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <InputMask
                                        mask="(99)99999-9999"
                                        maskChar={null}
                                        value={form.contato}
                                        onChange={(ev) => this.handleChangeMask(ev)}
                                    >
                                        {() => <TextField
                                            className="mb-16"
                                            label="Celular"
                                            id="contato"
                                            name="contato"
                                            variant="outlined"
                                            fullWidth
                                            required
                                            InputLabelProps={{
                                                shrink: form.contato !== null
                                            }}
                                        />
                                        }
                                    </InputMask>
                                    <TextField
                                        className="mb-16"
                                        label="Email"
                                        type="email"
                                        name="email"
                                        value={form.email}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        className="mb-16"
                                        label="Senha"
                                        type="password"
                                        name="password"
                                        value={form.password}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <TextField
                                        className="mb-16"
                                        label="Confirmar senha"
                                        type="password"
                                        name="passwordConfirm"
                                        value={form.passwordConfirm}
                                        onChange={this.handleChange}
                                        variant="outlined"
                                        required
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <FormControl className="items-center">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="acceptTermsConditions"
                                                    checked={form.acceptTermsConditions}
                                                    onChange={this.handleChangeCheck} />
                                            }
                                            label={<TermoUso />}
                                        />
                                    </FormControl>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className="w-full mx-auto mt-16"
                                        aria-label="Register"
                                        disabled={!this.isFormValid()}
                                        onClick={() => this.handleSubmit()}
                                    >
                                        CRIAR CONTA
                                    </Button>
                                </div>
                                <div className="flex flex-col items-center justify-center pt-32 pb-24">
                                    <span className="font-medium">Já possui conta?</span>
                                    <Link className="font-medium" to="/pub-login">Fazer login</Link>
                                </div>
                            </CardContent>
                        </Card>
                    </FuseAnimate>
                </div>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showMessage: AppActions.showMessage,
        createUserAuth: Actions.createUserAuth,
    }, dispatch);
}

function mapStateToProps({ fuse, reducer }) {
    return {
        theme: fuse.settings.mainTheme,
        Register: reducer
    };
}

export default withReducer("reducer", RegisterReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterPage))));
